<highcharts-chart
  [Highcharts]="highcharts"
  [options]="chartOptions"
  [(update)]="chartUpdateFlag"
  [constructorType]="'stockChart'"
  [oneToOne]="true"
  style="width: 80vw; height: 75vh; display: block"
></highcharts-chart>
